// @flow
import * as React from 'react'
import { Container, DayOfWeek, DowsRow } from './elements'
import Row from '../../../core/Row'
import DateItem from '../DateItem'
import { isDateSameDay, isDateSameMonth } from '../utils'

// Types
import type { Month } from '../utils'

export type Props = {
  value?: any,
  onChange?: Function,
  month: Month,
}

/**
 * Component for showing one month. It is optimised to update only when selected
 * value changed related to this month. So, rerendered only a month that contains
 * new selected date or previous selected date.
 */
class MonthRow extends React.Component<Props> {
  shouldComponentUpdate(nextProps: Props) {
    const someMonthDate = nextProps.month.days[1][0].date
    return (
      nextProps.month !== this.props.month ||
      isDateSameMonth(nextProps.value, someMonthDate) ||
      isDateSameMonth(this.props.value, someMonthDate)
    )
  }

  render() {
    const { month, value, onChange } = this.props
    return (
      <Container>
        <DowsRow>
          <Row>
            {month.dows.map((dow, j) => (
              <DayOfWeek key={j}>{dow.name}</DayOfWeek>
            ))}
          </Row>
        </DowsRow>
        {month.days.map((row, j) => (
          <Row key={j}>
            {row.map((day, k) => (
              <DateItem
                key={k}
                selected={isDateSameDay(value, day.date)}
                onChange={onChange}
                past={day.past}
                empty={day.empty}
                today={day.today}
                date={day.date}
              >
                {day.dayNum}
              </DateItem>
            ))}
          </Row>
        ))}
      </Container>
    )
  }
}

export default MonthRow
